export default __webpack_public_path__ + "static/media/DSC_7355.196a4b2d.jpg";